export type ThemeType = 'global' | 'banking' | 'onboarding' | 'switch' | 'bbps' | 'analytics' | 'vendor' | 'slate' | 'blue';

export interface ThemeConfig {
    primary: string;
    foreground: string;
    accent: string;
    sidebarBackground: string;
    sidebarPrimary: string;
    background: string;
    card: string;
    cardForeground: string;
    border: string;
    muted: string;
    mutedForeground: string;
    success?: string;
    warning?: string;
    error?: string;
    info?: string;
    heroGradientFrom?: string;
    heroGradientTo?: string;
}

export const themes: Record<ThemeType, ThemeConfig> = {
    global: {
        primary: '221.2 83.2% 53.3%',
        foreground: '222.2 84% 4.9%',
        accent: '210 40% 96.1%',
        sidebarBackground: '240 5.3% 98%',
        sidebarPrimary: '221.2 83.2% 53.3%',
        background: '0 0% 100%',
        card: '0 0% 100%',
        cardForeground: '222.2 84% 4.9%',
        border: '214.3 31.8% 91.4%',
        muted: '210 40% 96.1%',
        mutedForeground: '215.4 16.3% 46.9%',
        success: '142.1 76.2% 36.3%',
        warning: '38 92% 50%',
        error: '0 84.2% 60.2%',
        info: '199 89% 48%',
        heroGradientFrom: '221.2 83.2% 53.3%',
        heroGradientTo: '162.1 76.2% 36.3%',
    },
    banking: {
        primary: '221.2 83.2% 53.3%',
        foreground: '222.2 84% 4.9%',
        accent: '210 40% 96.1%',
        sidebarBackground: '222.2 47.4% 11.2%',
        sidebarPrimary: '221.2 83.2% 53.3%',
        background: '210 40% 98%',
        card: '0 0% 100%',
        cardForeground: '222.2 84% 4.9%',
        border: '214.3 31.8% 91.4%',
        muted: '210 40% 96.1%',
        mutedForeground: '215.4 16.3% 46.9%',
        success: '142.1 76.2% 36.3%',
        warning: '38 92% 50%',
        error: '0 84.2% 60.2%',
        info: '199 89% 48%',
        heroGradientFrom: '221.2 83.2% 53.3%',
        heroGradientTo: '142.1 76.2% 36.3%',
    },
    onboarding: {
        primary: '162.1 76.2% 36.3%', // XpressLinc Teal
        foreground: '240 5.3% 4.9%',
        accent: '162.1 76.2% 95%',
        sidebarBackground: '162.1 76.2% 10%',
        sidebarPrimary: '162.1 76.2% 36.3%',
        background: '162.1 70% 99%',
        card: '162.1 70% 100%',
        cardForeground: '240 5.3% 4.9%',
        border: '162.1 31.8% 90%',
        muted: '162.1 40% 96.1%',
        mutedForeground: '162.1 16.3% 46.9%',
        success: '162.1 76.2% 36.3%',
        warning: '38 92% 50%',
        error: '0 84.2% 60.2%',
        info: '199 89% 48%',
        heroGradientFrom: '162.1 76.2% 36.3%',
        heroGradientTo: '142.1 76.2% 36.3%',
    },
    switch: {
        primary: '239 84% 67%', // Switch Indigo
        foreground: '240 5.3% 4.9%',
        accent: '239 84% 95%',
        sidebarBackground: '239 84% 10%',
        sidebarPrimary: '239 84% 67%',
        background: '239 70% 99%',
        card: '239 70% 100%',
        cardForeground: '240 5.3% 4.9%',
        border: '239 31.8% 90%',
        muted: '239 40% 96.1%',
        mutedForeground: '239 16.3% 46.9%',
        success: '142.1 76.2% 36.3%',
        warning: '38 92% 50%',
        error: '0 84.2% 60.2%',
        info: '199 89% 48%',
        heroGradientFrom: '239 84% 67%',
        heroGradientTo: '142.1 76.2% 36.3%',
    },
    bbps: {
        primary: '15 100% 60%', // BBPS Orange
        foreground: '240 5.3% 4.9%',
        accent: '15 100% 95%',
        sidebarBackground: '15 100% 10%',
        sidebarPrimary: '15 100% 60%',
        background: '15 100% 99%',
        card: '15 100% 100%',
        cardForeground: '240 5.3% 4.9%',
        border: '15 100% 90%',
        muted: '15 40% 96.1%',
        mutedForeground: '15 16.3% 46.9%',
        success: '142.1 76.2% 36.3%',
        warning: '38 92% 50%',
        error: '0 84.2% 60.2%',
        info: '199 89% 48%',
        heroGradientFrom: '15 100% 60%',
        heroGradientTo: '15 100% 40%',
    },
    analytics: {
        primary: '262.1 83.3% 57.8%', // Analytics Purple
        foreground: '240 5.3% 4.9%',
        accent: '262.1 83.3% 95%',
        sidebarBackground: '262.1 83.3% 10%',
        sidebarPrimary: '262.1 83.3% 57.8%',
        background: '262.1 70% 99%',
        card: '262.1 70% 100%',
        cardForeground: '240 5.3% 4.9%',
        border: '262.1 31.8% 90%',
        muted: '262.1 40% 96.1%',
        mutedForeground: '262.1 16.3% 46.9%',
        success: '142.1 76.2% 36.3%',
        warning: '38 92% 50%',
        error: '0 84.2% 60.2%',
        info: '199 89% 48%',
        heroGradientFrom: '262.1 83.3% 57.8%',
        heroGradientTo: '262.1 83.3% 40%',
    },
    vendor: {
        primary: '221.2 83.2% 53.3%',
        foreground: '222.2 84% 4.9%',
        accent: '210 40% 96.1%',
        sidebarBackground: '240 5.3% 98%',
        sidebarPrimary: '221.2 83.2% 53.3%',
        background: '0 0% 100%',
        card: '0 0% 100%',
        cardForeground: '222.2 84% 4.9%',
        border: '214.3 31.8% 91.4%',
        muted: '210 40% 96.1%',
        mutedForeground: '215.4 16.3% 46.9%',
    },
    slate: {
        primary: '215.4 16.3% 46.9%',
        foreground: '222.2 84% 4.9%',
        accent: '210 40% 96.1%',
        sidebarBackground: '240 5.3% 98%',
        sidebarPrimary: '215.4 16.3% 46.9%',
        background: '0 0% 100%',
        card: '0 0% 100%',
        cardForeground: '222.2 84% 4.9%',
        border: '214.3 31.8% 91.4%',
        muted: '210 40% 96.1%',
        mutedForeground: '215.4 16.3% 46.9%',
    },
    blue: {
        primary: '221.2 83.2% 53.3%',
        foreground: '222.2 84% 4.9%',
        accent: '210 40% 96.1%',
        sidebarBackground: '240 5.3% 98%',
        sidebarPrimary: '221.2 83.2% 53.3%',
        background: '0 0% 100%',
        card: '0 0% 100%',
        cardForeground: '222.2 84% 4.9%',
        border: '214.3 31.8% 91.4%',
        muted: '210 40% 96.1%',
        mutedForeground: '215.4 16.3% 46.9%',
    }
};
